import React from "react";
import { useCtxReferences, useIsAuthed } from "utils/selectors";
import { getManifestLiveVariation } from "utils/mapStateToProps";
import { Formik, useFormikContext } from "formik";
import InfoNotice from "components/InfoNotice";
import EmbedPage from "components/EmbedPage";
import UnauthedAccountPrompt from "components/UnauthedAccountPrompt";
import { getEmbedInitialValues } from "utils/embed";

const AuthedPublishEmbed = () => {
  const { values } = useFormikContext();
  const manifest = values.manifest;
  const { application } = useCtxReferences();

  const manifestLiveVariation = getManifestLiveVariation({
    id: manifest.id,
    application
  });
  if (!manifestLiveVariation || !manifestLiveVariation.route) {
    return <InfoNotice copy="Publish page to a location first." />;
  }

  return (
    <Formik initialValues={getEmbedInitialValues({ application, manifest })}>
      {() => <EmbedPage />}
    </Formik>
  );
};

const UnauthedPublishEmbed = () => (
  <UnauthedAccountPrompt
    header="Embed anywhere"
    subheader="Sign up to create and embed pages anywhere using your own products and prices."
  />
);

const PublishEmbed = (props) => {
  const isAuthed = useIsAuthed();
  return isAuthed ? (
    <AuthedPublishEmbed {...props} />
  ) : (
    <UnauthedPublishEmbed {...props} />
  );
};

export default PublishEmbed;
